var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big_head"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.year)+"·历程 "),_c('br'),_c('span',{staticClass:"theme"},[_vm._v(_vm._s(_vm.theme))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }